import { JSXElement, mergeProps, splitProps } from 'solid-js';
import { ark, HTMLArkProps } from '@ark-ui/solid';
import { twMerge } from 'tailwind-merge';

type TrProps = HTMLArkProps<'tr'>;

export default function Tr(props: TrProps): JSXElement {
  const merged = mergeProps(
    {
      class: ''
    },
    props
  );
  const [split, rest] = splitProps(merged, ['class', 'children']);
  return (
    <ark.tr
      class={twMerge(`border-t border-t-fg-disabled`, split.class)}
      {...rest}
    >
      {split.children}
    </ark.tr>
  );
}
